import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorkplace = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.013 2q2.062 0 3.875.787a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175Q22 9.925 22 11.987a9.7 9.7 0 0 1-.787 3.888 10.1 10.1 0 0 1-2.15 3.188 10.2 10.2 0 0 1-3.175 2.15 9.6 9.6 0 0 1-3.875.787 9.7 9.7 0 0 1-3.888-.787 10.15 10.15 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.188A9.7 9.7 0 0 1 2 11.987q0-2.062.787-3.875a10.2 10.2 0 0 1 2.15-3.174 10.1 10.1 0 0 1 3.188-2.15A9.7 9.7 0 0 1 12.013 2M6 7.25V17h12V8.6h-6V7.25L9 5zm2.4 8.55H7.2v-1.2h1.2zm8.4 0H9.6v-6h7.2zm-6-1.2H12v-1.2h-1.2zm2.4 0h2.4v-1.2h-2.4zm-4.8-1.2H7.2v-1.2h1.2zm2.4-1.2H12V11h-1.2zm2.4 0h2.4V11h-2.4zM8.4 11H7.2V9.8h1.2zm0-2.4H7.2V7.4h1.2zm2.4 0H9.6V7.4h1.2z" })
});
export default SvgWorkplace;
